import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = ({ children, requireActiveSubscription = false, adminOnly = false }) => {
  const { user, loading, canAccessContent, isAdmin, isSuperAdmin } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">Loading...</div>
      </div>
    );
  }

  if (!user) {
    // Redirect to login with return path
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (adminOnly && !isAdmin() && !isSuperAdmin()) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requireActiveSubscription && !canAccessContent()) {
    return <Navigate to="/subscription" replace />;
  }

  return children;
};

export default ProtectedRoute;
